import type { ApiResumeType } from '@/app/api/resume+api';
import { Loading } from '@/components/loading';
import { useAuthedApi } from '@/hooks/use-authed-api';
import { generateAPIUrl } from '@/utils/api-url';
import { Redirect, useLocalSearchParams } from 'expo-router';
import { fetch as expoFetch } from 'expo/fetch';
import { hc } from 'hono/client';
import { useCallback } from 'react';

const client = hc<ApiResumeType>(generateAPIUrl('/'), {
  fetch: expoFetch as unknown as typeof fetch
});

async function fetchLatestPersona(
  token: string,
  {
    personaId,
    personaImportId
  }: { personaId: string | undefined; personaImportId: string | undefined }
) {
  const res = await client.api.resume.$post(
    { json: { personaId, personaImportId } },
    { headers: { Authorization: `Bearer ${token}` } }
  );

  return res.json();
}

export default function Index() {
  const { personaId, personaImportId } = useLocalSearchParams() as {
    personaId: string | undefined;
    personaImportId: string | undefined;
  };
  const fetchLatestPersonaCallback = useCallback(
    (token: string) =>
      fetchLatestPersona(token, { personaId, personaImportId }),
    [personaId, personaImportId]
  );
  const { loading, data } = useAuthedApi(fetchLatestPersonaCallback);

  if (loading) {
    return <Loading />;
  }

  switch (data.redirectTo) {
    case 'chat':
      return <Redirect href={`/chat/${data.id}`} />;
    case 'persona-archive':
      return <Redirect href={`/persona-archive/${data.id}`} />;
    case 'persona-import':
      if (data.id) {
        return <Redirect href={`/persona-import/preview/${data.id}`} />;
      }
      return <Redirect href="/persona-import?first=1" />;
    case 'persona-import/process':
      return <Redirect href={`/persona-import/process/${data.id}`} />;
    default:
      return <Redirect href="/persona-import?first=1" />;
  }
}
